<h2 mat-dialog-title class="mat-headline-medium">{{ "DIALOGS.MISSING_ROLE.TITLE" | translate }}</h2>
<mat-dialog-content>
  <div>{{ "DIALOGS.MISSING_ROLE.ROLE_REQUIRED" | translate }}</div>
  {{ rolesRequired }}
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-raised-button color="primary" mat-dialog-close [routerLink]="['/']">
    <mat-icon>home</mat-icon>
    <span>{{ "DIALOGS.MISSING_ROLE.BTN_BACK" | translate }}</span>
  </button>
  <a mat-raised-button color="accent" [mat-dialog-close]="true" (click)="onGotoLogin()">
    <mat-icon>refresh</mat-icon>
    <span>{{ "DIALOGS.MISSING_ROLE.BTN_LOGIN" | translate }}</span>
  </a>
</mat-dialog-actions>
